export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5595.2e37f417.jpg";